import 'css-chunksrc/client/scenes/listDuplication/listsList/list/event/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_8qmmv_1",
  "form": "_form_8qmmv_6",
  "name": "_name_8qmmv_1",
  "icon": "_icon_8qmmv_26",
  "input": "_input_8qmmv_30",
  "late": "_late_8qmmv_51",
  "completed": "_completed_8qmmv_58",
  "edition": "_edition_8qmmv_65"
};